<template>
  <v-sheet
    class="footer-banner d-none d-md-block"
    color="ui-kit-bg-secondary"
  >
    <v-img
      src="/graphics/footer-banner.svg"
      cover
    >
      <v-container>
        <div class="d-flex justify-space-between align-end mt-4">
          <span>
            <v-img
              width="319"
              height="415"
              src="images/features/patient/medtochka_home_page.png"
              srcset="images/features/patient/medtochka_home_page.png 1x,
                      images/features/patient/medtochka_home_page_3x.png 3x"
              alt="Главная страница медточки"
            />
          </span>

          <div class="mt-2">
            <div class="text-h3 mb-4">
              Скачайте приложение и будьте <br /> хозяином своих медицинских данных
            </div>
            <div class="text-ui-kit-text-secondary mt-2 text-landing-body-1">
              Доступно на AppStore, Google Play, AppGallery, GetApps и RuStore
            </div>
            <div class="d-flex my-6">
              <v-img
                alt="qr код приложения"
                class="flex-grow-0"
                width="184"
                height="184"
                :src="locale.isCis ? '/images/qr-medtochka-cis.png' : '/images/qr-medtochka.png'"
              />
              <div class="text-landing-body-2 text-ui-kit-text-secondary ml-4">
                Отсканируйте QR-код<br />для загрузки приложения
              </div>
            </div>
          </div>
        </div>
      </v-container>
    </v-img>
  </v-sheet>
  <v-sheet class="d-block d-md-none footer-banner_mobile px-6 py-8 bg-ui-kit-bg-secondary">
    <v-img
      src="/images/favicons/favicon.svg"
      max-width="80"
    />
    <div class="text-h5 my-4">
      Скачайте приложение и будьте хозяином своих медицинских данных
    </div>
    <div class="text-body-1 text-ui-kit-text-secondary">
      Доступно на AppStore, Google Play, AppGallery, GetApps и RuStore
    </div>
    <BaseMtButton
      class="mt-6"
      color="primary"
      @click="handleDownloadButtonClick"
    >
      Скачать приложение
    </BaseMtButton>
  </v-sheet>
</template>

<script setup lang="ts">
import { LINK_DOWNLOAD_MEDTOCHKA_APP } from '~/constants/links'

const locale = useAppLocale()

function handleDownloadButtonClick() {
  window.location.assign(LINK_DOWNLOAD_MEDTOCHKA_APP)
}
</script>

<style lang="scss">
.patient-features {
  .footer-banner {
    margin-top: 120px;
  }

  .footer-banner_mobile {
    margin-top: 56px;
  }
}
</style>
